export default {"src":"/_next/static/media/calendar.2411896f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};